import { render, staticRenderFns } from "./UserRegistrationPro.vue?vue&type=template&id=133335fe&scoped=true&lang=html&"
import script from "./UserRegistrationPro.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationPro.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationPro.vue?vue&type=style&index=0&id=133335fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133335fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VLayout,VSelect,VTextField})
